import { MoneyDisplay } from '../common/MoneyDisplay';
import { RowActions } from '../common/RowActions';
import { horizonLabel, resolveEffectiveHorizon } from '../../lib/accountsDisplay';
import { HORIZON_HEX } from './LiquidityHorizonDonut';
import pt from '../../locales/pt';
import { categoryMeta } from './assetCategories';

/**
 * `.pen` → `ds/row/composition-item` (variante activa, dentro de
 * `AccountTypeGroup`): chip uniforme sage + nome + etiqueta de horizonte
 * (ponto colorido `$horizon-*` + label) + valor + acções editar/arquivar.
 * Sem cartão/borda próprios — vive dentro do cartão do grupo.
 */
export function AccountAssetRow({ account, balanceEur, onEdit, onArchive }) {
  const meta = categoryMeta(account.category);
  const Icon = meta.icon;
  const horizon = resolveEffectiveHorizon(account);

  return (
    <div className="flex min-w-0 items-center gap-space-3">
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-ds-md bg-sage-tint text-sage-on-tint">
        <Icon size={16} aria-hidden />
      </span>

      <button
        type="button"
        className="min-w-0 flex-1 text-left"
        onClick={() => onEdit?.(account)}
      >
        <p className="truncate type-body font-semibold text-foreground">{account.name}</p>
        <div className="mt-0.5 flex items-center gap-1.5">
          <span
            className="h-1.5 w-1.5 shrink-0 rounded-full"
            style={{ backgroundColor: HORIZON_HEX[horizon] ?? HORIZON_HEX.days_2_5 }}
            aria-hidden
          />
          <span className="type-chip font-semibold text-muted-foreground">
            {horizonLabel(horizon)}
          </span>
        </div>
      </button>

      <div className="flex shrink-0 items-center gap-0.5">
        {balanceEur > 0 ? (
          <MoneyDisplay
            value={balanceEur}
            className="font-display text-type-display-row font-bold text-foreground"
          />
        ) : (
          <span className="font-display text-type-display-row font-bold text-stone-400">
            {pt.accounts.summaryCard.noBalance}
          </span>
        )}
        <RowActions
          item={account}
          onEdit={onEdit}
          onArchive={onArchive}
          editLabel={pt.accounts.actions.edit}
          archiveLabel={pt.accounts.actions.archive}
        />
      </div>
    </div>
  );
}
